export const EVENTS = {
    WEB_COMPONENT_PROJECTS_LOADED: 'WEB_COMPONENT_PROJECTS_LOADED',
    WEB_COMPONENT_ANCHOR_LOADED: 'WEB_COMPONENT_ANCHOR_LOADED',
    WEB_COMPONENT_FIRST_COMPONENT_DISPLAYED: 'WEB_COMPONENT_FIRST_COMPONENT_DISPLAYED'
}
export const BREAKPOINT_L = 996
export const BREAKPOINT_XL = 1920
export const BREAKPOINT_M = 768

// Components include in foundation, we skip the loading
export const excludeList = [
    'next-components/icon/',
    'next-components/cta/',
    'next-components/container/',
    'next-components/link/',
    'next-components/img/',
    'next-components/loader/',
    'next-components/add-to-cart/'
]
